var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 169,
    viewBox: "0 0 160 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#AA182C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.125 122.438C70.125 119.688 71.2292 117.229 73.4375 115.062C75.6875 112.896 78.1667 111.812 80.875 111.812C83.5833 111.812 85.7917 112.625 87.5 114.25C89.25 115.875 90.125 118.125 90.125 121C90.125 123.875 88.8542 126.542 86.3125 129C84.3958 130.667 82.125 131.5 79.5 131.5C76.875 131.5 74.6458 130.667 72.8125 129C71.0208 127.375 70.125 125.188 70.125 122.438ZM87 102.625C84.625 103.667 82.2917 104.188 80 104.188C77.75 104.188 75.5417 103.917 73.375 103.375C73.375 103.25 73.2708 102.458 73.0625 101C72.8542 99.5 72.6667 98.0208 72.5 96.5625C72.3333 95.1042 72.125 93.0625 71.875 90.4375C71.625 87.8125 71.3958 84.8125 71.1875 81.4375C70.9792 78.0625 70.7708 74.2083 70.5625 69.875C70.1458 61.4167 69.8542 50.0208 69.6875 35.6875C74.3542 34.8958 78.375 34.5 81.75 34.5C85.1667 34.5 87.9375 34.8958 90.0625 35.6875C88.2292 59.3958 87.2083 81.7083 87 102.625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.35949fe2b9d963b556cb6e27629ff6db.svg";
export { ForwardRef as ReactComponent };